export const REGULAR_ENGINEER_PRICE_CAP = 2_000_000;
export const REGULAR_ENGINEER_PRICE_CAP_LABEL = "Rp2.000.000";
